export const USER_HANDLE_MIN_LENGTH = 3;
export const USER_HANDLE_MAX_LENGTH = 30;

const USER_HANDLE_PATTERN = /^[a-zA-Z0-9_.-]+$/;

export const getUserHandleError = (handle, { required = false } = {}) => {
  if (!handle) {
    return required ? "User handle is required." : "";
  }

  if (!USER_HANDLE_PATTERN.test(handle)) {
    return "Only letters, numbers, underscores, hyphens, and periods are allowed. Spaces are not allowed.";
  }

  if (handle.length < USER_HANDLE_MIN_LENGTH) {
    return `User handle must be at least ${USER_HANDLE_MIN_LENGTH} characters.`;
  }

  if (handle.length > USER_HANDLE_MAX_LENGTH) {
    return `User handle must be no more than ${USER_HANDLE_MAX_LENGTH} characters.`;
  }

  return "";
};

export const isValidUserHandle = (handle, options) =>
  getUserHandleError(handle, options) === "";
